export default __webpack_public_path__ + "static/media/ic_notifications.d114e7e4.svg";